import { PageHero } from "@/components/layout/PageHero";

const SECTIONS = [
  {
    title: "1. About This Website",
    body: "This website is operated by SIREE SOLUTIONS GROUPS (SSS GROUPS) to present our services and receive business enquiries. By using this website, you agree to these Terms and Conditions.",
  },
  {
    title: "2. Services Description",
    body: "Service descriptions on this website are provided for general information. The exact scope, pricing, timelines, and terms of any service are defined in individual quotations and agreements between SSS GROUPS and the client. Certain services, including security and manpower deployment, are delivered subject to applicable licensing and employment law requirements. Healthcare-related offerings are non-clinical support services; SSS GROUPS does not provide medical treatment or licensed clinical services.",
  },
  {
    title: "3. Enquiries and Quotations",
    body: "Submitting an enquiry or quote request through this website does not create a binding contract. A service relationship is formed only upon written acceptance of a quotation or execution of a service agreement.",
  },
  {
    title: "4. Intellectual Property",
    body: "All content on this website — including text, design, logos, and imagery — is the property of SSS GROUPS or its licensors and may not be reproduced without written permission.",
  },
  {
    title: "5. Acceptable Use",
    body: "You agree not to misuse this website, attempt unauthorized access to any of its systems, submit false or misleading information, or use the website for any unlawful purpose.",
  },
  {
    title: "6. Limitation of Liability",
    body: "While we strive for accuracy, the content of this website is provided \u201cas is\u201d without warranties of any kind. SSS GROUPS is not liable for any indirect or consequential loss arising from use of this website.",
  },
  {
    title: "7. Changes to These Terms",
    body: "We may revise these Terms and Conditions at any time. Continued use of the website after changes are posted constitutes acceptance of the revised terms.",
  },
  {
    title: "8. Contact",
    body: "Questions about these Terms and Conditions may be directed to SSS GROUPS through our Contact page.",
  },
];

const TermsPage = () => (
  <div data-testid="terms-page">
    <PageHero
      eyebrow="Legal"
      title="Terms & Conditions"
      description="The terms that govern the use of the SIREE SOLUTIONS GROUPS website and the services described here."
    />
    <section className="bg-white py-20">
      <div className="mx-auto max-w-3xl space-y-10 px-6 lg:px-10">
        <p className="text-sm text-slate-500">Last updated: January 2026</p>
        {SECTIONS.map((s) => (
          <div key={s.title}>
            <h2 className="font-serif text-xl font-bold text-navy-900">{s.title}</h2>
            <p className="mt-3 leading-relaxed text-slate-600">{s.body}</p>
          </div>
        ))}
      </div>
    </section>
  </div>
);

export default TermsPage;
